import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useState} from 'react'
import {useFragment} from 'react-relay'

import useDocumentTitle from '../hooks/useDocumentTitle'
import useRouter from '../hooks/useRouter'
import {PALETTE} from '../styles/paletteV3'
import AuthPrivacyFooter from './AuthPrivacyFooter'
import {AUTH_DIALOG_WIDTH} from './AuthenticationDialog'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import EmailPasswordAuthForm from './EmailPasswordAuthForm'
import GoogleOAuthButtonBlock from './GoogleOAuthButtonBlock'
import HorizontalSeparator from './HorizontalSeparator/HorizontalSeparator'
import InvitationCenteredCopy from './InvitationCenteredCopy'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'
import PlainButton from './PlainButton/PlainButton'






const StyledDialog = styled(InviteDialog)({
  maxWidth: AUTH_DIALOG_WIDTH
})

const StyledContent = styled(DialogContent)({
  paddingLeft: 0,
  paddingRight: 0
})

const CopyMargins = styled('div')({
  padding: '0 1.5rem'
})

const UseEmailFallback = styled(PlainButton)({
  margin: '1rem',
  color: PALETTE.SKY_500
})

const TeamName = styled('span')({
  fontWeight: 600,
  whiteSpace: 'nowrap'
})

const TeamInvitationGoogleCreateAccount = (props) => {
  const [isEmailFallback, setIsEmailFallback] = useState(false)
  const {match} = useRouter()
  const {params} = match
  const {token: invitationToken} = params
  const {verifiedInvitation: verifiedInvitationRef} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationGoogleCreateAccount_verifiedInvitation on VerifiedInvitationPayload {
        meetingName
        teamInvitation {
          email
        }
        teamName
      }
    `,
    verifiedInvitationRef
  )
  const {meetingName, teamInvitation, teamName} = verifiedInvitation

  const useEmail = () => {
    setIsEmailFallback(true)
  }

  useDocumentTitle(`Sign up with Google | Team Invitation`, 'Team Invitation')
  if (!teamInvitation) return null
  const {email} = teamInvitation
  return (
    _jsxs(StyledDialog, { children: [
      _jsx(DialogTitle, { children: meetingName ? `Join ${meetingName}` : 'Join Team'})
      , _jsxs(StyledContent, { children: [
        _jsxs(CopyMargins, { children: [
          _jsx(InvitationDialogCopy, { children: "It looks like your email is hosted by Google."        })
          , _jsxs(InvitationDialogCopy, { children: ["Tap below for immediate access"

            , meetingName ? ' to the team meeting for: ' : ' to your team: '
            , _jsx(TeamName, { children: teamName})
          ]})
        ]})
        , _jsxs(InvitationCenteredCopy, { children: [
          _jsx(GoogleOAuthButtonBlock, { isCreate: true, loginHint: email, invitationToken: invitationToken,} )
          , isEmailFallback ? (
            _jsx(HorizontalSeparator, { margin: "1rem 0 0"  , text: "or",} )
          ) : (
            _jsx(UseEmailFallback, { onClick: useEmail, children: "Sign up without Google"   })
          )
          , isEmailFallback && (
            _jsx(EmailPasswordAuthForm, { email: email, invitationToken: invitationToken,} )
          )
        ]})
        , _jsx(AuthPrivacyFooter, {} )
      ]})
    ]})
  )
}

export default TeamInvitationGoogleCreateAccount
